import React, { useState } from 'react';
import { Users } from 'lucide-react';
import styles from './TeamCard.module.css';

// Global cache for TeamCard images to avoid skeleton flicker if already downloaded
const imageCache = new Set();
const ONLINE_BASE_URL = 'https://assets.cinbiosis.com/people';

const TeamCard = ({ name, role, desc, imageFilename }) => {
  const imageUrl = imageFilename ? `${ONLINE_BASE_URL}/${imageFilename}` : null;
  const hasImage = !!imageUrl;

  const [imgError, setImgError] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(() => imageUrl ? imageCache.has(imageUrl) : false);

  const shouldShowPlaceholder = !hasImage || imgError;
  const shouldShowSkeleton = hasImage && !imgError && !imgLoaded;

  return (
    <div className={styles.teamCard}>
      <div className={styles.avatarWrapper}>
        {shouldShowPlaceholder && (
          <div className={`${styles.avatar} ${styles.avatarPlaceholder}`}>
            <Users size={64} className={styles.placeholderIcon} />
          </div>
        )}

        {hasImage && !imgError && (
          <>
            {/* Skeleton Loading while image loads */}
            {shouldShowSkeleton && <div className={`${styles.avatar} ${styles.skeleton}`} />}

            <img
              src={imageUrl}
              alt={`Fotografía de ${name}`}
              className={`${styles.avatar} ${imgLoaded ? styles.loaded : styles.hidden}`}
              loading="lazy"
              onLoad={() => {
                imageCache.add(imageUrl);
                setImgLoaded(true);
              }}
              onError={() => setImgError(true)}
            />
          </>
        )}
      </div>

      <div className={styles.cardContent}>
        <h4 className={styles.name}>{name}</h4>
        <p className={styles.role}>{role}</p>
        <p className={styles.desc}>{desc}</p>
      </div>
    </div>
  );
};

export default TeamCard;
